module.exports = __webpack_public_path__ + "1.4.15-unryo/img/customize.d0549061.jpg";